import {AbstractControl} from '@angular/forms';

export class PasswordValidation {

    static MatchPassword(AC: AbstractControl) {
        let password = AC.get('newPass').value; // to get value in input tag
        let confirmPassword = AC.get('confirmPass').value; // to get value in input tag
        if (password != confirmPassword) {
            AC.get('confirmPass').setErrors({MatchPassword: true})
        } else {
            return null
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/resetClave/password-validation.ts